const initialState = {
  list: {
    isLoading: false,
    error: '',
    paginationOptions: {
      ordering_column_id: null,
      ordering: 'token',
      page: 1,
      size: 50,
    },
    data: {
      selected: [],
      items: [],
      count: 0,
    },
  },
  add: {
    isLoading: false,
    error: '',
  },
  show: {
    isLoading: false,
    error: '',
    data: {},
  },
  update: {
    isLoading: false,
    error: '',
  },
  delete: {
    isLoading: false,
    error: '',
  },
};

export default initialState;
